import React from "react";
import Header from "../../Header1";
import Footer from "../../Footer1";
import Title from "./Title";
import Terms from "./Terms";

const TermsAndConditions = () => {
	return (
		<>
			<Header />
			<Title />
			<Terms />
			<Footer />
		</>
	);
};
export default TermsAndConditions;
